import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import './DashboardMetrics/styles.css';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const HeadingTitle = ({ title, viewMoreLink, showCount= false ,children, style={}, download=null}) => {
  return (
    <div className="heading-title" style={style}>
      <Box display="flex" justifyContent="space-between" alignItems="center" className="heading-title-Box">
        <div className="heading-title-left-icon"></div>
        <div className="d-flex align-items-center">
          <Typography className="heading-title-text">{title}</Typography>
          {showCount !== false && (
            <span className="heading-title-count">{showCount}</span>
          )}
        </div>
        {download && download}
        {viewMoreLink && (
          <Link to={viewMoreLink} className="view-more-link">
            <p>View More</p>{" "}
            <ArrowForwardIosIcon sx={{ fontSize: 12, ml: 0.5 }} />
          </Link>
        )}
      </Box>
      {children}
    </div>
  );
};

export default HeadingTitle; 